import React, { useState } from 'react'
import Header from '../../Components/Header'
import Happy from '../../Assetes/Images/happy-imj.png'
import Love from '../../Assetes/Images/love.png'
import Sad from '../../Assetes/Images/sad.png'
import Angry from '../../Assetes/Images/angry.png'
import Excited from '../../Assetes/Images/excited.png'
import { useTranslation } from 'react-i18next'

export default function RateUS() {

    const [isVisible, setIsVisible] = useState(false);
    const [isSubmit, setIsSubmit] = useState(true);
    const [isShow, setIsShow] = useState(false);
    const [activeImageIndex, setActiveImageIndex] = useState(null);

    const toggleVisibility = (index:any) => {
        setActiveImageIndex(index);
        setIsVisible(true);
    };

    const handleOnSubmit = () => {
        setIsSubmit(false);
        setIsShow(true);
    }
    const { t } = useTranslation();

    return (
        <>
            <Header />
            <div className='container'>
                <div className='about-us'>
                    <div className='rate-box'>
                        <div>
                            {isSubmit && (
                                <div>
                                    <h5>{t("HOW_WOULD_YOU_RATE_EXPERIENCE")}</h5>
                                    <div className='select-emojy'>
                                        <img onClick={() => toggleVisibility(0)} src={Love} alt="" className={activeImageIndex === 0 ? 'active-img' : ''} />
                                        <img onClick={() => toggleVisibility(1)} src={Excited} alt="" className={activeImageIndex === 1 ? 'active-img' : ''} />
                                        <img onClick={() => toggleVisibility(2)} src={Happy} alt="" className={activeImageIndex === 2 ? 'active-img' : ''} />
                                        <img onClick={() => toggleVisibility(3)} src={Sad} alt="" className={activeImageIndex === 3 ? 'active-img' : ''} />
                                        <img onClick={() => toggleVisibility(4)} src={Angry} alt="" className={activeImageIndex === 4 ? 'active-img' : ''} />
                                    </div>
                                    {isVisible && (
                                        <div className='input-rateus'>
                                            <div className="searchbox-wrap">
                                                <input type="text" placeholder={t("FEEDBACK_PLACEHOLDER")} />
                                                <button onClick={handleOnSubmit}><span>{t("SEND")}</span> </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        {isShow && (
                            <div className='thankyou-box'>
                                <i className="ri-checkbox-circle-line"></i>
                                <h4>{t("THANK_YOU_FEEDBACK")}</h4>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}


